import React from 'react';
import { Typography } from '@material-ui/core';

import useStyles from './styles';

import footerLogo from '../../assets/Logo+New+Marimetrics-13.WebP';

const Footer = () => {
    const classes = useStyles();
    return (
        <>
            <div className={classes.footerDiv}>
                <div className={classes.floatLeft}>
                    <Typography className={`${classes.footerTypography} ${classes.footerHeader}`} variant="h2">Marimetrics AS</Typography>
                    <Typography className={classes.footerTypography} variant="h2">Forskningsparken - Oslo Science Park</Typography>
                    <Typography className={classes.footerTypography} variant="h2">Gaustadallèen 21, 0349 Oslo</Typography>
                    <Typography className={classes.footerTypography} variant="h2">Norway</Typography>
                    <Typography className={`${classes.footerTypography} ${classes.footerCopyright}`} variant="h2">©️ 2023 Marimetrics AS</Typography>
                </div>
                <img className={`${classes.floatRight} ${classes.footerImage}`} src={footerLogo} alt="Marimetrics" />
            </div>
        </>
    )
}

export default Footer
